import { render } from "./NodeAdminComponent.vue?vue&type=template&id=3fa215cc&ts=true"
import script from "./NodeAdminComponent.vue?vue&type=script&lang=ts"
export * from "./NodeAdminComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__